export const startMission = {
  Proficiency: "Beginner",
  Link: "https://48a2203acb4efa1f65.gradio.live",
  TilesetURL:
    "https://storage.googleapis.com/lingolandhq.appspot.com/elvishbeginnerolivia20231030150543/tileset?Expires=2014063697&GoogleAccessId=firebase-adminsdk-n3mq4%40lingolandhq.iam.gserviceaccount.com&Signature=AXOyuqC408tWb479IhiVv86zEOP69s7Tf5vQhgFJAevRYaJwDe3boKuKqAqMr8BMtaaL9xZ7lC%2FmRRDeYUGiRFrpR0U4S9H7To3OdhKR8zT3lavkDFZGqDsGF%2F4kEbhErv%2BbUbC0YCP%2BJhPRrU9Bnv3hW%2BOjYqABOfNDLP1UHOiXM1RUGQ47ttxaB%2FC4psJfUoPEF7n19zFe35JtG5%2BhIMIpeVc2j6lWWdw4halN5TR4uPbmMo8SYB0H%2BwIbW791LuGK264wWgJWcOXtCp%2FvOhrLz5OfueRwjZrHG7QwtzBzQcbD8nJRxmciXiGXurxZFrVtUgQ8pfoQv%2Bbsv5uRbQ%3D%3D",
  Role: "Florist",
  Buildings: [
    {
      BuildingURL:
        "https://storage.googleapis.com/lingolandhq.appspot.com/elvishbeginnerolivia20231030150543/Herb%20Store/building?Expires=2014063705&GoogleAccessId=firebase-adminsdk-n3mq4%40lingolandhq.iam.gserviceaccount.com&Signature=4dYVZJkgoQ7zvRybi3O7pBmyEhWY2Ffp3THTfUcO25eXVtWsCGg9l2n4QynPDCUmMVOXxouPDe6dArwqIC%2BodFhX6haYcWeR7G3VWXWeuhr6HIXQLbb00FyG81BUEYaRnEt1uE9AnNnxYIX3nAn19HjeZD%2BKuykzsYP3yJamPtzFaRi8gMYjtFYYF7vk%2FYVyoznYnKv6s66ATMK3k9XspT46yBKyIXH7vnDGzM1lQrpHdEgYzgJKk%2B1gAKRZbzHNpL3nny3TTgcvIgl6P6%2FkKGfFRHgktn%2F%2FHmk6ZUw6pWba%2F21P84C0cx2KbOfTRwo5B91k06cPoK4tDs8%2BLRkL%2FA%3D%3D",
      Items: "ginseng, lavender",
      Characters: [
        {
          Name: "AI Instructor Leo",
          SpriteAssetURL:
            "../characters/lionsprite.png",
          Reward: "Petite pouch of magical herbs",
          Task: {
            Detail:
              "Learn about a medicinal herb and its Elvish name from Eara. Describe your favorite flower to her in Elvish.",
            Title: "Herb Harmony",
          },
          RewardAssetURL:
            "https://storage.googleapis.com/lingolandhq.appspot.com/elvishbeginnerolivia20231030150543/Herb%20Store/Eara/reward?Expires=2014063728&GoogleAccessId=firebase-adminsdk-n3mq4%40lingolandhq.iam.gserviceaccount.com&Signature=kvIGzYbzUbbLmZeiC3hFjUFHtXH7uRp7W8lpPFYSmQrEAWF1cdc4Zb3TW94bGOiMU%2FvWeghlxy0cpAi%2Bhr33fXk2Vz6Rs62W5LTZcDHZWw9tviJusXL3E3RUyeVD5sgAFaAutaBYJDjbBh%2Fum8QLn5is5hK8MxS4e%2FyQXRRWtQCieeCMTteaahDtEfaBq1%2BGghOKrmVa7flVH0%2FRJszrZLmH%2FhcBFguKpwY01VchCsncJJI%2FhyfEqrkk5iNhngbfsdcCTr56usN9XF8vYFjA1mSGBWNakyOcFlPISpddSel6KH%2Fk2K2XOLqEAh3fT0Y%2Fw80NzxWcDnEGshWEMRI40w%3D%3D",
          ProfileAssetURL:
            "https://firebasestorage.googleapis.com/v0/b/htmaaland.appspot.com/o/AITA%2Fleo.png?alt=media&token=980943d1-e28f-4157-a3f5-9a51d95159b5",
          Backstory:
            "🦁",
        },
      ],
      Name: "Herb Store",
    },
    {
      Name: "Greenhouse",
      Items: "exotic plants, watering can",
      BuildingURL:
        "https://storage.googleapis.com/lingolandhq.appspot.com/elvishbeginnerolivia20231030150543/Greenhouse/building?Expires=2014063736&GoogleAccessId=firebase-adminsdk-n3mq4%40lingolandhq.iam.gserviceaccount.com&Signature=BcUUa%2BD9HKWVLLP5QmnWaNHiHFoZvPrOHtWGfdNKSIhNFrJRhD0V3KgAlMEA%2BzToimjKuKcZfsTpByaD0djLk3CLHTATIwMyvhshwtPNLbLMXfjJtjNcAKsH9kM%2BnMD%2BxpASrn%2BVSbEvLGbVtXv7H6qG%2B86J9eRJIbFTd53W0VmAC%2BHf4AR2IKBd3%2FpIuKjIdYOYpoHWK2QaHUp9Yr1rToCf96dnqoo%2Frk%2F%2F%2FlLK5WxVCcLUIyiE0yE%2Fh3cfzgTjt5lwrcyzJ8%2BbdkOaWYqSiRTEdhtFPjoFso%2BkH4QURdXxOEfED7C36m3yRr8TbH227Ck6kp%2F%2Bit6bgYzTU7VLYA%3D%3D",
      Characters: [
        {
          Reward: "Bright blooming Elvish flower",
          RewardAssetURL:
            "https://storage.googleapis.com/lingolandhq.appspot.com/elvishbeginnerolivia20231030150543/Greenhouse/Lior/reward?Expires=2014063757&GoogleAccessId=firebase-adminsdk-n3mq4%40lingolandhq.iam.gserviceaccount.com&Signature=h%2B2%2B5DMF9UHgsAyr6rlNWf4NlRsbo9%2BFbfzTjeT6PGh%2BzFLevmLTqUOmLRpXLid18z%2FhAqSTX4PSmV6ey06UJZTE97JGGA%2FYMOOXEVw4lSEHDH5YqkTPTfNcNcWGn0bKp3KXiyWS6F9qsLjCEVDLTIbvVGynvQ46zXpsFi6qonlSzRi8cV%2BpOpcoP3QM7S8xr2R5r4Uy14BR8oi5KnT8ZWZWeba3kY6DDT3nQJiKZXoVDtMLpQ05KXuGCw92G%2BTNyTjjlXOvI9XwSjXlVPEonq1zD9TrvXQDQnm%2FRqjXvMlPYWt5h8czi9diqZiUALLBr9ELej73RoC9397t%2FfXsZA%3D%3D",
          SpriteAssetURL:
            "https://firebasestorage.googleapis.com/v0/b/lingolandhq.appspot.com/o/sprite%20(5).png?alt=media&token=7b39ad7b-b065-4b8b-9409-a588bf5be4f7&_gl=1*11wkyj9*_ga*MTI0OTcwNzE5My4xNjk4MTA2OTIz*_ga_CW55HF8NVT*MTY5ODY5OTQxNy4yMC4xLjE2OTg3MDM5NjguMzAuMC4w",
          Name: "AI Instructor Quentin",
          Task: {
            Detail:
              "Get Lior to show you an Elvish plant. Express awe and ask about its care requirements in Elvish.",
            Title: "Botanical Bliss",
          },
          Backstory:
            "Responsible elf",
          ProfileAssetURL:
            "https://firebasestorage.googleapis.com/v0/b/htmaaland.appspot.com/o/AITA%2Fquentin.png?alt=media&token=6914b706-345c-4c98-b786-cf5c388af249",
        },
      ],
    },
    {
      Characters: [
        {
          ProfileAssetURL:
            "https://firebasestorage.googleapis.com/v0/b/htmaaland.appspot.com/o/AITA%2Fanthony.png?alt=media&token=e615454f-0b29-44f8-be0a-f778d08a4479",
          Name: "AI Instructor Anthony",
          Backstory:
            "What Would Anthony Do?",
          SpriteAssetURL:
          "../characters/anthonysprite.png",
          Reward: "Handmade Elvish flora wreath",
          RewardAssetURL:
            "https://storage.googleapis.com/lingolandhq.appspot.com/elvishbeginnerolivia20231030150543/Flowery%20Meadow/Fael/reward?Expires=2014063787&GoogleAccessId=firebase-adminsdk-n3mq4%40lingolandhq.iam.gserviceaccount.com&Signature=sIQEDMVdZK1Ou9A7z2Pi3NX1k5%2FWJawIrfyDkBSh9hDlxXEPK8Gg3vVPd5JsEGpHRRxCwYyRKwHNKrqWVPX94mr30YfQppfQ5BgnFBEZcFDTEorvOPu2dAK0tewqaw0cMqzZGUWJcmB7DtwpPkqB8okGOiGNeOTh0GdoLVAzvZMRTanu5OwUTyJp0ZtWhPYEXzmPiEVvJA8%2B%2F1OnFLbtcRgo4iStg6qgW3PjYTtA8khYL%2BCBv7avrcDJUfbvyoJvaXQ8jzPfMvNsrSGgq%2F2Xma7TxWoc1DFEHRZ8smOFvYAOwMSo1d2HEqb8j8oKIvK3%2BhBohjXC6rmwtFXy1LN3pg%3D%3D",
          Task: {
            Title: "Meadow Magic",
            Detail:
              "Sit with Fael on the blanket and ask him to name the wildlife around. Respond in Elvish with phrases of appreciation.",
          },
        },
      ],
      Items: "wildflowers, cozy picnic blanket",
      Name: "Flowery Meadow",
      BuildingURL:
        "https://storage.googleapis.com/lingolandhq.appspot.com/elvishbeginnerolivia20231030150543/Flowery%20Meadow/building?Expires=2014063765&GoogleAccessId=firebase-adminsdk-n3mq4%40lingolandhq.iam.gserviceaccount.com&Signature=VZ8NjUAHsaxhXKPwZjcMfG9FODSs6osszGYaXCNCdc4Z8GwT83TVV%2FJszMsZv30IvECRbcFNmLAm%2Ftxpgxx2uB0kFl0ihEZgZKhlCaaq3aXIYf5KpeuorZET3EgcwqvOjxhAu4NgAv%2B2KPMxv2CXaISqsWGDnYqvYQs2eoOGnA2N1I%2Fw9MO%2FvNGKxk0lkhQWjsyFhQSKqZmXNXDHkLgl%2FD1aTIALlEMKgzrNJvsn%2Bh%2FdgLxvGpKT%2FYM8hB%2F5AKhaoFGy7%2B0TpXT3QXcde%2FmQeIqDDciyuBS5m2dJJsy7LFyBHbAt72swowWtFVtuWqtHjD2KZ1euVdXxUlQHqQKSCw%3D%3D",
    },
  ],
  Location: "Elvish Enclave",
  TimeCreated: {
    seconds: 1698703543,
    nanoseconds: 328000000,
  },
  Language: "Elvish",
  Completed: false,
  MissionTitle: "Fauna and Flora: An Elvish Bloom Adventure!",
  Mission_Id: "elvishbeginnerolivia20231030150543",
  AssetsGenerated: true,
  PaletteURL: "./palettes/lost-century-24.png",
};
